// extracted by mini-css-extract-plugin
module.exports = {"intro__title":"styles_intro__title__0H4Z5","intro__subtitle":"styles_intro__subtitle__3w8TD","intro__image":"styles_intro__image__HAbzE"};